import { AddCircleOutline, Close } from '@mui/icons-material';
import {
  Box,
  Chip,
  IconButton,
  InputAdornment,
  TextField,
} from '@mui/material';
import { Contact } from 'lib/api/contacts/types';
import React, { useState } from 'react';

import AvalsDialog from './Dialog';
import { Aval } from './types';

interface Props {
  value: Aval[];
  onChange: (value: Aval[]) => void;
  businessUsers?: Contact[];
}

const Avals: React.FC<Props> = ({ value, onChange, businessUsers }) => {
  const [open, setOpen] = useState(false);
  const [aval, setAval] = useState<Aval>({ type: 'SAME_COMPANY' });

  const handleDeleteAval = (index: number) => {
    const newAvals = (value || []).filter((_, i) => i !== index);
    onChange(newAvals);
  };

  const hasAvals = value && value.length > 0;

  return (
    <>
      <TextField
        fullWidth
        label="Avales"
        value=""
        placeholder={hasAvals ? '' : 'Seleccionar avales'}
        onClick={() => setOpen(true)}
        InputProps={{
          readOnly: true,
          startAdornment: hasAvals ? (
            <Box
              sx={{
                display: 'flex',
                flexWrap: 'wrap',
                gap: 0.5,
                maxWidth: 'calc(100% - 60px)',
                mr: 1,
                py: 2,
              }}
            >
              {value.map((aval, index) => (
                <Chip
                  key={`${aval.signer?.identifier}-${index}`}
                  label={`${aval.signer?.name || 'Sin nombre'}`}
                  size="small"
                  variant="outlined"
                  color="primary"
                  onDelete={(e) => {
                    e.stopPropagation();
                    handleDeleteAval(index);
                  }}
                  sx={{
                    maxWidth: '180px',
                    '& .MuiChip-label': {
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                    },
                  }}
                />
              ))}
            </Box>
          ) : null,
          endAdornment: (
            <InputAdornment position="end">
              {hasAvals ? (
                <IconButton
                  edge="end"
                  onClick={(e) => {
                    e.stopPropagation();
                    onChange([]);
                  }}
                  size="small"
                >
                  <Close />
                </IconButton>
              ) : (
                <IconButton
                  edge="end"
                  onClick={() => setOpen(true)}
                  size="small"
                >
                  <AddCircleOutline />
                </IconButton>
              )}
            </InputAdornment>
          ),
        }}
        sx={{ cursor: 'pointer' }}
        margin="dense"
      />
      <AvalsDialog
        open={open}
        setOpen={setOpen}
        aval={aval}
        setAval={setAval}
        value={value}
        onChange={onChange}
        businessUsers={businessUsers ?? []}
      />
    </>
  );
};

export default Avals;
